const CONSENT_KEY = 'privacy_consent_accepted';

export function hasPrivacyConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === '1';
  } catch {
    return false;
  }
}

export function acceptPrivacyConsent(): void {
  try {
    localStorage.setItem(CONSENT_KEY, '1');
  } catch {
    // localStorage unavailable — treat as accepted for this session
  }
}

export function revokePrivacyConsent(): void {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch {
    // ignore
  }
}
